<script setup lang="ts">
import OpenJobDetailsIconLink from '@/components/iconLinks/OpenJobDetailsIconLink.vue';
import * as routeNames from '@/constants/routeNames';

export interface Props {
  jobId?: number;
  jobDate?: string;
}
const props = withDefaults(defineProps<Props>(), {
  jobId: NaN,
  jobDate: '',
});
</script>

<template>
  <article
    :class="$style.jobIdAndIconLinkUnit"
    data-testid="jobIdAndIconLinkUnit"
  >
    {{ props.jobId
    }}<v-lazy class="d-inline"
      ><OpenJobDetailsIconLink
        :class="$style.btn"
        :to="{
          name: routeNames.DETAILED_QUERY_JOB,
          query: {
            job_id: props.jobId,
            job_date: props.jobDate,
          },
        }"
      />
    </v-lazy>
  </article>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.jobIdAndIconLinkUnit {
  white-space: nowrap;
  display: inline;
}
  .btn {
    margin-top: -8.6px;
    margin-bottom: -7px;
    vertical-align: middle;
    /* TODO the size of the outline is not changing */
    /* font-size: 85.714% !important; */

    :global {
      .v-icon {
        /* font-size: 150%; */
      }
    }
  }
</style>
